import axios from '../http'

function add(data) {
    return axios.post('/basedata/teamAthlete/add', data);
}

function del(data) {
    return axios.post('/basedata/teamAthlete/del', data);
}

function update(data) {
    return axios.post('/basedata/teamAthlete/update', data);
}

function query(data) {
    return axios.post('/basedata/teamAthlete/query', data);
}


function get(id) {
    return axios.get('/basedata/teamAthlete/get?id=' + id);
}


function find(data) {
    return axios.post('/basedata/teamAthlete/find', data);
}

export default {
    add,
    del,
    update,
    query,
    get,
    find
}